export default __webpack_public_path__ + "static/media/Recreation_Logotipo vetorizado_V2_MONO WHT.9d6ac163.svg";